<div class="right_data_all candidateOffer">
    <!-- Link expired: responsive message + main content hidden -->
    <div *ngIf="linkExpired" class="link-expired-wrapper">
        <div class="link-expired-card">
            <div class="link-expired-icon">
                <mat-icon fontIcon="schedule"></mat-icon>
            </div>
            <h1 class="link-expired-title">Link Expired</h1>
            <p class="link-expired-message">This job application link is no longer active.</p>
            <p class="link-expired-sub">The position may have been closed or the link has expired. Thank you for your interest.</p>
        </div>
    </div>

    <!-- Main content: only when manpower status is OPEN -->
    <ng-container *ngIf="!linkExpired">
        <mat-card class="candidate_Details candidate_Details2">
            <mat-card-header>
                <!-- <mat-card-title class="TopHeading">
                <h4>External Job Advertisement - {{ no_of_position }} - {{reference_number}}</h4>
            </mat-card-title>
            <mat-card-subtitle>
                <p class="midHeading">{{company_Branch}}</p>

            </mat-card-subtitle> -->

                <div class="d-flex justify-content-start align-items-start">
                    <div class="icon-box">
                        <mat-icon>business_center</mat-icon>
                    </div>
                    <div class="heading d-flex flex-column">
                        <h2>External Job Advertisement </h2>
                        <p class="sub-text">{{ no_of_position }} - {{reference_number}}</p>
                        <p class="midHeading d-flex ps-2 mt-2"><mat-icon>apartment</mat-icon> {{company_Branch}}</p>
                    </div>
                </div>


            </mat-card-header>

            <mat-card-actions class="p-4 card-actions-wrap">
                <a *ngIf="jobDataBy?.jobSpecification == 'YES'" href="{{generateImageUrl()+jobDataBy?.upload_document}}"
                    download target="_blank">
                    <button mat-button class="downloadButton" (click)="downloadJD()">
                        Download JD
                        <mat-icon aria-hidden="false" aria-label="Example download" fontIcon="download"></mat-icon>
                    </button>
                </a>
                <button *ngIf="jobDataBy?.jobSpecification == 'NO'" mat-button class="downloadButton"
                    (click)="openDialog()">
                    View JD
                    <mat-icon aria-hidden="false" aria-label="Example download" fontIcon="download"></mat-icon>
                </button>

           
            </mat-card-actions>
        </mat-card>


        <div class="main  candidate_Details">
            <div class="row mt-4">
                <div class="col-12">
                    <mat-card class="form-card candidate_Details2">
                        <mat-card-title>
                            <h3>Fill the below Form</h3>
                        </mat-card-title>
                        <mat-card-content>
                            <form [formGroup]="myForm">

                                <!-- First row with three fields -->
                                <div class="row">
                                    <div class="col-xxl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                        <div class="form-group mb-3">
                                            <mat-label>Location <span class="alertspan">*</span></mat-label>
                                            <mat-form-field appearance="outline">
                                                <input matInput formControlName="location" placeholder="" readonly tabindex="-1">
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="col-xxl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                        <div class="form-group mb-3">
                                            <mat-label>Job title <span class="alertspan">*</span></mat-label>
                                            <mat-form-field appearance="outline">
                                                <input matInput formControlName="job_title" placeholder="" readonly tabindex="-1">
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="col-xxl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                        <div class="form-group mb-3">
                                            <mat-label>Job Position<span class="alertspan">*</span></mat-label>
                                            <mat-form-field appearance="outline">
                                                <input matInput formControlName="position" placeholder=" " readonly tabindex="-1">
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>

                                <!-- Remaining fields -->
                                <div class="row">
                                    <div class="col-xxl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                        <div class="form-group mb-3">
                                            <mat-label>Expected
                                                End Date <span class="alertspan">*</span></mat-label>
                                            <mat-form-field appearance="outline">
                                                <input matInput [matDatepicker]="dp3" (click)="dp3.open()"
                                                    formControlName="end_date" readonly tabindex="-1" />
                                                <mat-datepicker-toggle [disabled]="true" matSuffix
                                                    [for]="dp3"></mat-datepicker-toggle>
                                                <mat-datepicker #dp3></mat-datepicker>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="col-xxl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                        <div class="form-group mb-3">
                                            <mat-label>Department <span class="alertspan">*</span></mat-label>
                                            <mat-form-field appearance="outline">
                                                <input matInput formControlName="department" placeholder="" readonly tabindex="-1">
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="col-xxl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                        <div class="form-group mb-3">
                                            <mat-label>Sub Department <span class="alertspan">*</span></mat-label>
                                            <mat-form-field appearance="outline">
                                                <input matInput formControlName="area" readonly tabindex="-1">
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>


                                <div class="row">
                                    <div class="col-xxl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                        <div class="form-group mb-3">
                                            <mat-label> Experience (in Months or Years)<span
                                                    class="alertspan">*</span></mat-label>
                                            <mat-form-field appearance="outline">
                                                <input matInput formControlName="exp_required" readonly tabindex="-1">
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="col-xxl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                        <div class="form-group mb-3">
                                            <mat-label>Level of Interview <span class="alertspan">*</span></mat-label>
                                            <mat-form-field appearance="outline">
                                                <input matInput formControlName="level_of_interview" readonly
                                                    tabindex="-1">
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="col-xxl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                        <div class="form-group mb-3">
                                            <mat-label>Qualification<span class="alertspan">*</span></mat-label>
                                            <mat-form-field appearance="outline">
                                                <input matInput formControlName="qualification" readonly tabindex="-1">
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div class="form-group mb-3">
                                            <mat-label>Skills Required<span class="alertspan">*</span></mat-label>
                                            <mat-form-field appearance="outline">
                                                <input matInput formControlName="skill" readonly tabindex="-1">
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-xxl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                        <div class="form-group mb-3">
                                            <mat-label>First Name <span class="alertspan">*</span></mat-label>
                                            <mat-form-field appearance="outline">
                                                <input matInput formControlName="first_name" placeholder="Enter first name"
                                                    (input)="removeSpaces($event)">
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="col-xxl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                        <div class="form-group mb-3">
                                            <mat-label>Middle Name</mat-label>
                                            <mat-form-field appearance="outline">
                                                <input matInput formControlName="middle_name" placeholder="Enter middle name"
                                                    (input)="removeSpaces($event)">
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="col-xxl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                        <div class="form-group mb-3">
                                            <mat-label>Last Name <span class="alertspan">*</span></mat-label>
                                            <mat-form-field appearance="outline">
                                                <input matInput formControlName="last_name" placeholder="Enter last name"
                                                    (input)="removeSpaces($event)">
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-xxl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                        <div class="codeArea">
                                            <div class="form-group addCoding">
                                                <mat-form-field class="country-codes" appearance="outline">
                                                    <mat-select formControlName="country_code" placeholder="Select">
                                                        <app-search-filter [array]="countryCodeList"
                                                            [placeholder]="'Search'" [searchFields]="['dialing_code']"
                                                            valueKey="dialing_code" class="country-search"
                                                            (filteredReturn)="filteredCountryCodeList2 = $event.data">
                                                        </app-search-filter>
                                                        <mat-option *ngFor="let countryCode of filteredCountryCodeList2"
                                                            [value]="countryCode?.dialing_code">
                                                            +{{ countryCode?.dialing_code }}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                            <div class="form-group">
                                                <mat-label>Contact Number <span class="alertspan">*</span></mat-label>
                                                <mat-form-field appearance="outline">
                                                    <input matInput type="number" formControlName="contact_number" placeholder="Enter contact number" />
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-xxl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                        <div class="form-group mb-3">
                                            <mat-label>Email<span class="alertspan">*</span></mat-label>
                                            <mat-form-field appearance="outline">
                                                <input matInput formControlName="email" (input)="removeSpaces($event)" placeholder="Enter Email address">
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="col-xxl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                        <div class="form-group mb-3">
                                            <mat-label>Resume <span class="alertspan">*</span></mat-label>
                                            <input class="form-control file-input-resp" style="padding: 9px;" type="file" multiple="true"
                                                title="CHOOSE FILE" #fileInput (change)="onChangeCv($event)"
                                                formControlName="cv_upload" accept=".pdf,.doc,.docx"
                                                [class.file-input-error]="myForm.get('cv_upload')?.invalid && myForm.get('cv_upload')?.touched" />
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </mat-card-content>
                    </mat-card>
                </div>
            </div>
            <div class="answereArea form-card  candidate_Details2">
                <h3 class="ms-0">Please Give Your Answer</h3>
                <div class="responsive-table">
                    <table class="table questions-table">
                        <thead>
                            <tr>
                                <th class="border">S.No</th>
                                <th class="border">Questions</th>
                                <th class="border">Answer</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of allJobArray?.getAllData_question; index as i" class="question-row">
                                <td class="border" data-label="S.No">{{ i + 1 }}</td>
                                <td class="border" data-label="Question">{{ item.question }} <span
                                        class="alertspan">*</span></td>
                                <td class="border answer-cell" data-label="Answer">
                                    <mat-form-field appearance="outline" class="question-answer-field"
                                        [class.field-error]="item.hasAnswerError">
                                        <mat-select formControlName="question_answer_user" placeholder="Select Answer"
                                            (selectionChange)="getAnswer(item,$event)">
                                            <mat-option value="YES">YES</mat-option>
                                            <mat-option value="NO">NO</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-form-field *ngIf="item.selection_answer === 'Other'" appearance="outline"
                                        class="custom-answer-field" [class.field-error]="item.hasError">
                                        <input matInput placeholder="Please specify" [(ngModel)]="item.customAnswer"
                                            #customAnswer="ngModel" [required]="item.selection_answer === 'Other'"
                                            (ngModelChange)="onCustomAnswerChange(item, $event)" />
                                        <mat-error *ngIf="customAnswer.invalid && customAnswer.touched">
                                            This field is required
                                        </mat-error>
                                    </mat-form-field>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="row">
                <div class="col-xxl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="common_button_sub pt-0">
                        <button type="submit" class="btn-success rounded-1" (click)="onConfirmSubmitClick($event)">
                            Submit
                        </button>

                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</div>